import { type SwaggerDefinition, type SwaggerDefinitions, type SwaggerField } from '~/services/common';
// Slim copy written by server/utils/minify-data.ts: definitions plus each path method's summary (TICKET-2238).
// Kept out of services/common.ts, which every page imports, so it only ships with the pages that use it.
import SWAGGER from '~/data/swagger.min.json';

export { SWAGGER };

export function getDefinition(ref: string, noArray = false) {
    // console.log('getDefinition', ref);
    const DEFAULT = { properties: {}, required: [], type: '' } as SwaggerDefinition;
    if (!ref) {
        return DEFAULT;
    }

    const DEFS = SWAGGER.definitions as SwaggerDefinitions;
    ref = ref.replace('#/definitions/', '');

    let array = false;
    if (DEFS[ref]?.type === 'array' && DEFS[ref]?.items?.$ref) {
        ref = (DEFS[ref]?.items?.$ref as string) || '';
        ref = ref.replace('#/definitions/', '');
        array = true && !noArray;
        // console.log('def.array', ref);
        // return getDefinition(ref, false, true);
        // ref = ref.substring(0, ref.length - 1);
        // if (!noArray) {
        //     array = true;
        // }
    } else if (DEFS[ref]?.type === 'array' && DEFS[ref]?.items?.enum) {
        return { array: true, ...DEFS[ref]?.items } as SwaggerField;
    }

    if (DEFS[ref]?.additionalProperties) {
        //string map of additionalProperties.$ref
        const ref2 = DEFS[ref]?.additionalProperties?.$ref?.replace('#/definitions/', '') || '';
        if (DEFS[ref2]) {
            return { ...DEFS[ref], ...{ name: ref }, properties: DEFS[ref2]?.properties, ...{ type: 'map', format: 'string dictionary' } };
        }

        if (DEFS[ref]?.additionalProperties?.type) {
            // console.log(DEFS[ref]);
            return { ...DEFS[ref], ...{ name: ref }, ...{ type: 'map', format: 'string dictionary of ' + DEFS[ref]!.additionalProperties!.type } };
        }
    }

    // console.log('getDefinition', ref, DEFS[ref]);
    return { ...(DEFS[ref] || DEFAULT), ...{ array }, ...{ name: ref } };
}
